export default __webpack_public_path__ + "static/media/Photo 2 - BR - point d'eau.d7ab8c27.jpg";